module.exports = __webpack_public_path__ + "static/media/people.dec17c93.png";